import React from 'react';
import { STATUS_META } from '../../../entities/supportRequests/model/constants';
import type { RequestStatus } from '../../../entities/supportRequests/model/types';
import { cx } from '../../../utils/cx';
import styles from './StatusBadge.module.scss';

export interface StatusBadgeProps {
    status: RequestStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
    return <span className={cx(styles.badge, styles[status])}>{STATUS_META[status].label}</span>;
}
